// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"66bccd0b","560":"b1aca7ec"}[chunkId] + ".chunk.css";
};